import { Button, Col, Icon, Text } from 'components';
import { imageResizer } from 'core';
import { theme } from 'lib';
import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';

const UploadMedia = ({
  wid,
  ht,
  setData,
  handleNext = () => null,
  accept = '.jpeg, .jpg, .png, .mp4, .webm, .ogv'
}) => {
  const fileRef = useRef(null),
    { t } = useTranslation(),
    dispatch = useDispatch();

  function resizeImage({ imagePath, newWidth, newHeight }) {
    const originalImage = new Image();
    originalImage.src = imagePath;

    const canvas = document.getElementById('canvas');
    const ctx = canvas.getContext('2d');

    return new Promise((resolve) => {
      originalImage.addEventListener('load', () => {
        // get the original image size and aspect ratio
        const originalWidth = originalImage.naturalWidth,
          originalHeight = originalImage.naturalHeight,
          aspectRatio = originalWidth / originalHeight;

        // if the new height wasn't specified, use the width and the original aspect ratio
        if (newHeight === undefined) {
          // calculate the new height
          newHeight = newWidth / aspectRatio;
          newHeight = Math.floor(newHeight);
        }

        const upperScale = Math.max(newWidth / originalWidth, newHeight / originalHeight);

        //set the canvas size
        canvas.width = newWidth;
        canvas.height = newHeight;

        //render the image
        ctx.drawImage(
          originalImage,
          newWidth / 2 - (originalWidth * upperScale) / 2,
          0,
          originalWidth * upperScale,
          originalHeight * upperScale
        );

        canvas.toBlob((blob) => resolve(blob));
      });
    });
  }

  async function handleFile(e) {
    const files = Array.from(e?.target?.files);
    fileRef.current.value = '';
    if (!files.length) return;

    const hasVideo = files.find((x) => x.type.includes('video'));

    if (hasVideo) {
      if (hasVideo.size >= 104857600) {
        dispatch({
          type: 'HANDLE_RES',
          payload: { err: 'Video cannot be larger than 100 MB.' }
        });

        return;
      }

      setData((data) => ({
        ...data,
        media: [
          {
            uri: URL.createObjectURL(hasVideo),
            file: hasVideo
          }
        ]
      }));

      handleNext();

      return;
    }

    let mapped = [];

    for await (let file of files) {
      if ((mapped?.length || 0) >= 10) break;

      /*
        unused cropping code

        const uri = await resizeImage({
          imagePath: URL.createObjectURL(file),
          newWidth: 484,
          newHeight: 720
        })
      */

      const uri = await imageResizer({
        height: 1080,
        width: 1080,
        format: 'JPEG',
        file,
        output: 'blob',
        quality: 70
      });

      const thumbnail = await imageResizer({
        height: 300,
        width: 300,
        format: 'JPEG',
        file,
        output: 'blob',
        quality: 100
      });

      mapped.push({ uri, thumbnail, preview: URL.createObjectURL(uri) });
    }

    setData((data) => ({
      ...data,
      media: mapped
    }));

    handleNext();
  }

  return (
    <React.Fragment>
      <Col bg={theme.GREY_10} wid={wid || '296px'} ht={ht} pad="auto 36px" center centerAll noFlex>
        <Icon type="gallery" dimensions={48} col={theme.GREY_30} marg="8px" />

        <Text marg="24px" center b2 col={theme.GREY_60}>
          {t('add.fileFormats')}
        </Text>

        <Button
          wid="fit-content"
          text={t('common.uploadFile')}
          icon="upload"
          pad="0 24px"
          onClick={() => fileRef.current.click()}
        />

        <input
          // multiple
          type="file"
          ref={fileRef}
          accept={accept}
          style={{ width: 0, height: 0, opacity: 0 }}
          onChange={(event) => handleFile(event)}
        />
      </Col>

      <Col pos="fixed" style={{ opacity: 0 }} right="0">
        <canvas id="canvas" />
      </Col>
    </React.Fragment>
  );
};

export default UploadMedia;
